import React, {useRef, useMemo} from 'react';
import { useNavigate } from 'react-router-dom';
import Sec4ArrowSvg from '../../svgs/home/Sec4ArrowSvg.js'
import './home.css'
import '../../App.css'
import Sec3Slider from './Sec3Slider.js';
import TestSlider from './TestSlider.js'
import InViewComponent from '../../screens/components/InView.js';
import Slider from 'react-slick';
//
import CONTENT from '../../contents/home'
import BTN from '../../contents/btn'
//
import { useLang } from '../../hook/UseLang.js';

const imgArr = [
    './images/rooms/new_room/0.jpg',
    './images/rooms/new_room/1.jpg',
    './images/rooms/new_room/2.jpg',
    './images/rooms/new_room/3.jpg',
    // './images/rooms/new_room/4.jpg',
    // './images/rooms/new_room/5.jpg',
    // './images/rooms/new_room/6.jpg',
    // './images/rooms/new_room/7.jpg',
    // './images/rooms/new_room/8.jpg',
    // './images/rooms/new_room/9.jpg',
]
  const Home3 = () => {
    const navigate = useNavigate()
    const textRef = React.useRef(null);
    const [lang, setLang] = useLang();
    const sliderRef = useRef()
    
    const RealSlider = useMemo(() => {
            const settings = {
                dots: true, // Show dots for navigation
                infinite: true, // Enable infinite looping
                speed: 500, // Transition speed
                slidesToShow: 3, // Number of slides to show
                slidesToScroll: 1, // Number of slides to scroll
                arrows: true,
                autoplay: true,
                speed: 2000,
                autoplaySpeed: 2000,
                // afterChange: (indexOfCurrentSlide) => {
                //     handleIdxChange(
                //     indexOfCurrentSlide
                //     )
                // },
                dots:false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        }
                    },
                ]
        
            };
        return <Slider ref={sliderRef} {...settings}>
            {imgArr.map((src, index) => (
            <div key={index}>
                <div className='w-full flex flex-row items-center justify-center' style={{aspectRatio: '1920/1080', overflow: 'hidden'}}>
                    <img className='h-[100%]' src={src} alt={`Slide ${index}`} style={{ objectFit: 'cover'}}/>
                </div>
            </div>
            ))}
        </Slider>
    },[])
    return (
        <div className='w-full relative min-h-[97vh] py-[24px]'>
            <img src='./images/bg_texture.jpg' className='absolute top-0 left-0 w-full h-full' style={{objectFit: 'cover', zIndex:1}}></img>
            <div className='absolute top-0 left-0 w-full h-full bg-[#ffffff] opacity-[0.7]' style={{zIndex:2}}></div>
            <div className='relative w-full h-full flex flex-col items-center justify-center' style={{zIndex:3}}>
                <div ref={textRef} className='w-full flex flex-col items-center justify-center title_text mb-[24px]'>
                    <div className='text-homesec-title playfair-display' style={{letterSpacing:5}}>{CONTENT.sec3_0[lang]}</div>
                    {/* <div className='text-d-12 mt-[12px]'>{CONTENT.sec3_1[lang]}</div> */}
                    <div className='flex flex-col items-center justify-center mt-[24px]' style={{gap: 12}}>
                        <div className='text-d-12'>{CONTENT.sec3_2[lang]} </div>
                        <div className='text-d-12'>{CONTENT.sec3_3[lang]}</div>
                    </div>  
                </div>
                <div className='w-[70%] relative'>
                    {RealSlider}
                </div>
                <div onClick={() => navigate(`/rooms?lang=${lang}`)} className='mt-[48px] relative text-d-12 flex flex-row items-center justify-center w-[90%] max-w-[208px] py-[12px] border border-[#0FBAB5] text-[#0FBAB5] relative select-none cursor-pointer hover:bg-[#0FBAB5] hover:text-white transition-all duration-300 btn-arrow'>
                    <div className='relative'>{BTN.details[lang]}</div>
                    <div className='absolute right-[-16%] top-[46%] arrow-moveleft'>
                        <Sec4ArrowSvg/>
                    </div>
                </div>
                
                {/* <InViewComponent reffing={textRef} active='title_text_active' />
                <div className='w-full pt-[91px] relative d-flex-m-hidden' style={{overflowY:'visible'}}>
                <TestSlider />
                </div>
                <Sec3Slider /> */}
            </div>
        </div>
    );
};

export default Home3;

                    